interface DonationOptionProps {
  option: any;
  isActive: boolean;
  onClick: () => void;
}

const DonationOption = ({ option, isActive, onClick }: DonationOptionProps) => {
  return (
    <label
      className={`block cursor-pointer rounded-full border px-4 py-2 font-heading text-lg transition-colors duration-300 ease-in-out lg:min-w-[200px] lg:text-2xl ${
        isActive
          ? "border-primary bg-primary text-white"
          : "border-gray-400 bg-primary-light text-gray-500"
      }`}
    >
      <input
        type="radio"
        name="id"
        value={option.id}
        onClick={onClick}
        className="hidden"
        required
      />
      <span className="block">{option.label}</span>
    </label>
  );
};

export default DonationOption;
